class ContactPage {
  constructor() {
    this.$page = $('.contactPage');
    if (!this.$page.length) return;

    // フォームのエンドポイントマッピング
    this.formEndpoints = {
      'cancelForm': 'https://docs.google.com/forms/u/0/d/e/1FAIpQLSdNAmb9AE-kj5XdJNx6wggsSkWzm_6KWqkz_j0D7TkcKpR6wQ/formResponse',
      // 'cancelForm': 'https://docs.google.com/forms/u/0/d/e/1FAIpQLSeCzLNFVoeLebSvPX3pI_SFGxy3p_tJ1A0ibgtwFZbKFjGuug/formResponse',
    };

    // フォーム要素の特定
    this.$form = this.$page.find('form');
    this.formId = this.$form.attr('id');

    // フォームの各状態のコンテンツ要素
    this.$inputContent = this.$page.find('[data-state="input"]');
    this.$confirmContent = this.$page.find('[data-state="confirm"]');
    this.$completeContent = this.$page.find('[data-state="complete"]');

    // ボタン要素
    this.$confirmButton = this.$inputContent.find('.--button .c-button');
    this.$editButton = this.$confirmContent.find('.--button .c-button').eq(0);
    this.$submitButton = this.$confirmContent.find('.--button .c-button').eq(1);

    // 表示用とAPI送信用の別々のデータオブジェクトを用意
    this.displayData = {};
    this.formData = {};

    // メール存在チェック状態
    this.emailExists = null;
    this.isCheckingEmail = false;

    this.init();
  }

  init() {
    this.bindEvents();
    this.setupAttachmentWatcher();
    this.detectOrderSource();
    this.setupProductConditionalVisibilityV2();
    this.setupEmailExistCheck();
  }

  /**
   * 購入元の特定処理
   */
  detectOrderSource() {
    // 注文番号・購入元inputのjQuery取得
    const $orderInput = $('#contact_order');
    const $storeInput = $('#contact_store');

    $orderInput.on('input', function() {
      const val = $(this).val().trim();
      let storeName = '';

      if (/^OC-\d{12}-[a-zA-Z0-9]{3}-\d{6}$/.test(val)) {
        storeName = 'サブスクストア';
      } else if (/^\d{3}-\d{7}-\d{7}$/.test(val)) {
        storeName = 'Amazon';
      } else if (/^\d{4,8}$/.test(val)) {
        storeName = 'Shopify';
      } else {
        storeName = 'その他';
      }
      $storeInput.val(storeName);
    });
  }

  // 解約製品の選択肢に応じて該当項目を出し分ける
  setupProductConditionalVisibilityV2() {
    const STORE_RADIO_NAME = 'entry.801466152'; // ご契約されたストア

    // Amazon・楽天購入時のみ表示したい追加ラジオ（amazon / 楽天）
    // ※商品プラン条件とは独立して「購入ストア」選択にだけ依存
    const OTHER_STORE_DETAIL_FIELD = 'entry.843060629';

    const FIXED_NUMBER_DEVICE_FIELD = 'entry.521426564';

    const PRODUCT_RADIO_NAMES = [
      'entry.1978710870', // 【本体無料レンタル】定期便プラン
      'entry.2050220363', // 定期便プラン（消耗品のみ）
      'entry.1153183485', // レンタルプラン（本体のみ）
      'entry.1117288098', // care plan（※ラベル等は必要に応じて見直し）
    ];

    // 「ストア」 + 「製品ラジオ4グループ」は、表示セット定義上は常に見せる扱いにしておく
    // （実際の初期表示は applyVisibility 内で制御）
    const ALWAYS_VISIBLE_FIELDS = new Set([
      STORE_RADIO_NAME,
      ...PRODUCT_RADIO_NAMES,
    ]);

    // 製品ラジオ4グループを、各商品の表示セットに合成するための共通セット
    const BASE_FIELDS = [STORE_RADIO_NAME, ...PRODUCT_RADIO_NAMES];

    const VISIBLE_FIELDS_BY_PRODUCT_ID = {
      // プレミアムケアプラン
      purchase_care_plan: new Set([
        ...BASE_FIELDS,
        'entry.801466152',
        'entry.814531238',
        'entry.9543435',
        'entry.845802448',
        'entry.651189857',
        'email_confirm',
        'entry.890183971',
        'entry.1432097144',
        'entry.547797658',
      ]),

      // 本体無料レンタル（定期便セット）
      purchase_lala_renatl_cat_litter: new Set([
        ...BASE_FIELDS,
        'entry.814531238',
        'entry.9543435',
        'entry.845802448',
        'entry.651189857',
        'email_confirm',
        'entry.890183971',
        'entry.623478820',
        'entry.868100979',
        'entry.1432097144',
        'entry.547797658',
        'entry.521426564',
        'entry.966699525',
        'entry.1736121538',
        'entry.379981321',
        'entry.351754600',
      ]),
      purchase_coco_renatl_cat_litter: new Set([
        ...BASE_FIELDS,
        'entry.814531238',
        'entry.9543435',
        'entry.845802448',
        'entry.651189857',
        'email_confirm',
        'entry.890183971',
        'entry.623478820',
        'entry.868100979',
        'entry.1432097144',
        'entry.547797658',
        'entry.521426564',
        'entry.966699525',
        'entry.1736121538',
        'entry.379981321',
        'entry.351754600',
      ]),
      purchase_mimi_rental_cat_litter: new Set([
        ...BASE_FIELDS,
        'entry.814531238',
        'entry.9543435',
        'entry.845802448',
        'entry.651189857',
        'email_confirm',
        'entry.890183971',
        'entry.623478820',
        'entry.868100979',
        'entry.1432097144',
        'entry.547797658',
        'entry.521426564',
        'entry.966699525',
        'entry.1736121538',
        'entry.379981321',
        'entry.351754600',
      ]),
      purchase_mona_rental_water_dispenser_filter: new Set([
        ...BASE_FIELDS,
        'entry.814531238',
        'entry.9543435',
        'entry.845802448',
        'entry.651189857',
        'email_confirm',
        'entry.890183971',
        'entry.623478820',
        'entry.868100979',
        'entry.1432097144',
        'entry.547797658',
        'entry.521426564',
        'entry.966699525',
        'entry.1736121538',
        'entry.379981321',
        'entry.351754600',
      ]),

      // 定期便（消耗品のみ）
      purchase_subsc_cat_litter: new Set([
        ...BASE_FIELDS,
        'entry.814531238',
        'entry.9543435',
        'entry.845802448',
        'entry.651189857',
        'email_confirm',
        'entry.890183971',
        'entry.623478820',
        'entry.868100979',
        'entry.1432097144',
        'entry.547797658',
      ]),
      purchase_subsc_filter: new Set([
        ...BASE_FIELDS,
        'entry.814531238',
        'entry.9543435',
        'entry.845802448',
        'entry.651189857',
        'email_confirm',
        'entry.890183971',
        'entry.623478820',
        'entry.868100979',
        'entry.1432097144',
        'entry.547797658',
      ]),

      // レンタル（本体のみ）
      purchase_coco_renatl: new Set([
        ...BASE_FIELDS,
        'entry.814531238',
        'entry.9543435',
        'entry.845802448',
        'entry.651189857',
        'email_confirm',
        'entry.890183971',
        'entry.623478820',
        'entry.868100979',
        'entry.1432097144',
        'entry.547797658',
        'entry.521426564',
        'entry.966699525',
        'entry.1736121538',
        'entry.379981321',
        'entry.351754600',
      ]),
      purchase_mimi_renatl: new Set([
        ...BASE_FIELDS,
        'entry.814531238',
        'entry.9543435',
        'entry.845802448',
        'entry.651189857',
        'email_confirm',
        'entry.890183971',
        'entry.623478820',
        'entry.868100979',
        'entry.1432097144',
        'entry.547797658',
        'entry.521426564',
        'entry.966699525',
        'entry.1736121538',
        'entry.379981321',
        'entry.351754600',
      ]),
      purchase_mona_renatl: new Set([
        ...BASE_FIELDS,
        'entry.814531238',
        'entry.9543435',
        'entry.845802448',
        'entry.651189857',
        'email_confirm',
        'entry.890183971',
        'entry.623478820',
        'entry.868100979',
        'entry.1432097144',
        'entry.547797658',
        'entry.521426564',
        'entry.966699525',
        'entry.1736121538',
        'entry.379981321',
        'entry.351754600',
      ]),
      purchase_milo_set_renatl: new Set([
        ...BASE_FIELDS,
        'entry.814531238',
        'entry.9543435',
        'entry.845802448',
        'entry.651189857',
        'email_confirm',
        'entry.890183971',
        'entry.623478820',
        'entry.868100979',
        'entry.1432097144',
        'entry.547797658',
        'entry.521426564',
        'entry.966699525',
        'entry.379981321',
        'entry.351754600',
      ]),
      purchase_milo_core_renatl: new Set([
        ...BASE_FIELDS,
        'entry.814531238',
        'entry.9543435',
        'entry.845802448',
        'entry.651189857',
        'email_confirm',
        'entry.890183971',
        'entry.623478820',
        'entry.868100979',
        'entry.1432097144',
        'entry.547797658',
        'entry.521426564',
        'entry.966699525',
        'entry.379981321',
        'entry.351754600',
      ]),
      purchase_milo_home_renatl: new Set([
        ...BASE_FIELDS,
        'entry.814531238',
        'entry.9543435',
        'entry.845802448',
        'entry.651189857',
        'email_confirm',
        'entry.890183971',
        'entry.623478820',
        'entry.868100979',
        'entry.1432097144',
        'entry.547797658',
        'entry.521426564',
        'entry.966699525',
        'entry.379981321',
        'entry.351754600',
      ]),
    };

    const normalizeProductId = (id) => (id || '').replace(/-/g, '_');

    const getSelectedStoreId = () => {
      const checked = document.querySelector(`input[type="radio"][name="${STORE_RADIO_NAME}"]:checked`);
      return checked ? checked.id : null; // purchase_store_shopify / purchase_store_other
    };

    const getSelectedProductId = () => {
      for (const name of PRODUCT_RADIO_NAMES) {
        const checked = document.querySelector(`input[type="radio"][name="${name}"]:checked`);
        if (checked) return normalizeProductId(checked.id);
      }
      return null;
    };

    const getAllFieldItems = () => {
      // input/confirm 両方の dl を拾う（あなたのHTML構造と一致）
      return Array.from(document.querySelectorAll('.contactForm__item[data-fields]'));
    };

    const clearValuesWithin = (item) => {
      const inputs = item.querySelectorAll('input, select, textarea');

      inputs.forEach((el) => {
        const tag = el.tagName.toLowerCase();
        const type = (el.getAttribute('type') || '').toLowerCase();

        if (tag === 'select') {
          el.selectedIndex = 0;
          el.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }

        if (tag === 'textarea') {
          el.value = '';
          el.dispatchEvent(new Event('input', { bubbles: true }));
          return;
        }

        if (type === 'checkbox' || type === 'radio') {
          el.checked = false;
          el.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }

        el.value = '';
        el.dispatchEvent(new Event('input', { bubbles: true }));
      });
    };

    // heading 出し分け（id の - / _ どっちでも拾う）
    const $headingRental = document.querySelector('#heading-rental');
    const $headingSubsc = document.querySelector('#heading-subsc');

    // 製品カテゴリ定義（normalizeProductId 後のキーで統一）
    const HEADING_RENTAL_PRODUCTS = new Set([
      // 本体 + 定期お得便（あなたの要件では rental 側）
      'purchase_lala_renatl_cat_litter',
      'purchase_coco_renatl_cat_litter',
      'purchase_mimi_rental_cat_litter',
      'purchase_mona_rental_water_dispenser_filter',

      // レンタル本体
      'purchase_coco_renatl',
      'purchase_mimi_renatl',
      'purchase_mona_renatl',
      'purchase_milo_set_renatl',
      'purchase_milo_core_renatl',
      'purchase_milo_home_renatl',
    ]);

    const HEADING_SUBSC_PRODUCTS = new Set([
      // 消耗品のみ定期
      'purchase_subsc_cat_litter',
      'purchase_subsc_filter',
    ]);

    function applyHeadingVisibility(productId) {
      if (!$headingRental && !$headingSubsc) return;

      // 未選択 or プレミアムは両方非表示
      if (!productId || productId === 'purchase_care_plan') {
        if ($headingRental) $headingRental.style.display = 'none';
        if ($headingSubsc) $headingSubsc.style.display = 'none';
        return;
      }

      const showRental = HEADING_RENTAL_PRODUCTS.has(productId);
      const showSubsc = HEADING_SUBSC_PRODUCTS.has(productId);

      if ($headingRental) $headingRental.style.display = showRental ? '' : 'none';
      if ($headingSubsc) $headingSubsc.style.display = showSubsc ? '' : 'none';
    }

    function wrapStoreRadioLabelTextWithSpan() {
      const ids = ['purchase_store_shopify', 'purchase_store_other'];

      ids.forEach((id) => {
        const input = document.getElementById(id);
        if (!input) return;

        const label = document.querySelector(`label[for="${id}"]`);
        if (!label) return;

        // すでに span を入れていたら何もしない（多重ラップ防止）
        if (label.querySelector('.storeRadio__text')) return;

        // label直下のテキストをまとめて span で包む
        const span = document.createElement('span');
        span.className = 'storeRadio__text';

        // 既存の子要素を span に移す（テキスト以外が混ざっても壊れにくい）
        while (label.firstChild) {
          span.appendChild(label.firstChild);
        }
        label.appendChild(span);
      });
    }

    // ============================================================
    // ★追加：特定プラン選択時のポップアップ（☓で閉じたら従来挙動へ）
    // ============================================================
    const POPUP_TARGET_PRODUCT_IDS = new Set([
      // 「【本体無料レンタル】定期便プラン」の2つ
      'purchase_lala_renatl_cat_litter', // id: purchase_lala_renatl_cat-litter
      'purchase_coco_renatl_cat_litter', // id: purchase_coco_renatl_cat-litter
      'purchase_mimi_rental_cat_litter', // id: purchase_mimi_rental_cat-litter
    ]);

    let popupOnClose = null;

    function ensureCancelPlanPopup() {
      // CSS（1回だけ）
      const styleId = 'miruto-cancel-plan-popup-style';
      if (!document.getElementById(styleId)) {
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = `
          .mirutoModalOverlay{
            position:fixed; inset:0;
            background:rgba(0,0,0,.45);
            display:none;
            align-items:center; justify-content:center;
            z-index:99999;
            padding:16px;
          }
          .mirutoModal{
            background:#fff;
            width:min(520px, 100%);
            border-radius:16px;
            padding:22px 18px 18px;
            position:relative;
            box-shadow:0 12px 30px rgba(0,0,0,.18);
          }
          .mirutoModal__close{
            position:absolute; top:10px; right:10px;
            width:36px; height:36px;
            border:none; background:transparent;
            font-size:22px; line-height:1;
            cursor:pointer;
          }
          .mirutoModal__title{
            font-size:18px;
            font-weight:700;
            margin:0 0 10px;
          }
          .mirutoModal__desc{
            margin:0 0 14px;
            font-size:14px;
            line-height:1.7;
          }
          .mirutoModal__btn{
            display:block;
            text-align:center;
            padding:12px 14px;
            border-radius:12px;
            background:#111;
            color:#fff;
            text-decoration:none;
            font-weight:700;
          }
          .mirutoModal__btn:hover{ opacity:.9; }
        `;
        document.head.appendChild(style);
      }

      // DOM（1回だけ）
      if (document.getElementById('mirutoCancelPlanPopup')) return;

      const overlay = document.createElement('div');
      overlay.className = 'mirutoModalOverlay';
      overlay.id = 'mirutoCancelPlanPopup';
      overlay.innerHTML = `
        <div class="mirutoModal" role="dialog" aria-modal="true" aria-labelledby="mirutoCancelPlanPopupTitle">
          <button type="button" class="mirutoModal__close" aria-label="閉じる">×</button>
          <h3 class="mirutoModal__title" id="mirutoCancelPlanPopupTitle">ご案内</h3>
          <p class="mirutoModal__desc">
            こちらのプランでは24ヶ月以上継続の場合、無償で新品と交換させていただきます
          </p>
          <a class="mirutoModal__btn" target="_blank" rel="noopener"
             href="https://www.miruto.shop/pages/contact/?status=repair">
            製品の不具合の問い合わせはこちら
          </a>
        </div>
      `;
      document.body.appendChild(overlay);

      const closeBtn = overlay.querySelector('.mirutoModal__close');

      function closePopup(runOnClose) {
        overlay.style.display = 'none';
        document.body.style.overflow = '';
        document.removeEventListener('keydown', onKeyDown);

        const cb = popupOnClose;
        popupOnClose = null;

        if (runOnClose && typeof cb === 'function') cb();
      }

      function onKeyDown(e) {
        if (e.key === 'Escape') closePopup(true);
      }

      // 背景クリックで閉じる（中身クリックは無視）
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) closePopup(true);
      });

      // 右上☓
      closeBtn.addEventListener('click', () => closePopup(true));

      // 外から呼べるように
      overlay.__open = (onClose) => {
        popupOnClose = onClose || null;
        overlay.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        document.addEventListener('keydown', onKeyDown);
        setTimeout(() => closeBtn.focus(), 0);
      };
    }

    function openCancelPlanPopup(onClose) {
      ensureCancelPlanPopup();
      const overlay = document.getElementById('mirutoCancelPlanPopup');
      if (overlay && overlay.__open) overlay.__open(onClose);
    }
    // ============================================================

    const applyVisibility = () => {
      const storeId = getSelectedStoreId();
      let productId = getSelectedProductId();
      const $planHead = document.querySelector('.contactForm__head');

      // plan-attention（注意文エリア）の表示制御
      const $planAttention = document.querySelector('#plan-attention');
      const $buttonItem = document.querySelector('[data-state="input"] .contactForm__item.--button');

      // ① ストア未選択：ストア項目だけ表示
      if (!storeId) {
        applyHeadingVisibility(null);
        if ($planAttention) $planAttention.style.display = 'none';
        if ($buttonItem) $buttonItem.style.display = 'none';
        if ($planHead) $planHead.style.display = 'none';

        getAllFieldItems().forEach((item) => {
          const fieldKey = item.getAttribute('data-fields');
          const shouldShow = fieldKey === STORE_RADIO_NAME;

          if (shouldShow) {
            item.style.display = '';
            setDisabledWithin(item, false);
          } else {
            // 非表示 → 値クリアして、入力も無効化（FormDataから除外）
            if (fieldKey !== FIXED_NUMBER_DEVICE_FIELD) {
              clearValuesWithin(item);
            } else {
              // 「解約デバイス数」は固定で 1 を保持
              const el = item.querySelector(`#contact_device_id, input[name="${FIXED_NUMBER_DEVICE_FIELD}"]`);
              if (el) el.value = '1';
            }
            setDisabledWithin(item, true);
            item.style.display = 'none';
          }
        });
        return;
      }

      if ($planHead) $planHead.style.display = '';

      // ② Amazon/楽天：レンタルCocoを強制選択（初回のみ）
      if (storeId === 'purchase_store_other') {
        const coco = document.getElementById('purchase_coco_renatl');
        if (coco) {
          // 他グループは解除
          PRODUCT_RADIO_NAMES.forEach((n) => {
            document.querySelectorAll(`input[type="radio"][name="${n}"]`).forEach((el) => {
              el.checked = false;
            });
          });
          // レンタルCocoを選択
          coco.checked = true;
          productId = normalizeProductId(coco.id);
        }
      }

      applyHeadingVisibility(productId);

      if ($planAttention) {
        // premium or 未選択は非表示
        if (!productId || productId === 'purchase_care_plan') {
          $planAttention.style.display = 'none';
        } else {
          // rental/subsc のどちらかが表示されるときだけ出す
          const rentalVisible = $headingRental && $headingRental.style.display !== 'none';
          const subscVisible = $headingSubsc && $headingSubsc.style.display !== 'none';
          $planAttention.style.display = rentalVisible || subscVisible ? '' : 'none';
        }
      }

      // ③ Shopify公式：ストア選択後、製品未選択の間は「ストア + 製品ラジオ4グループ」だけ表示
      if (storeId === 'purchase_store_shopify' && !productId) {
        if ($planAttention) $planAttention.style.display = 'none';
        if ($buttonItem) $buttonItem.style.display = 'none';

        getAllFieldItems().forEach((item) => {
          const fieldKey = item.getAttribute('data-fields');
          const shouldShow = fieldKey === STORE_RADIO_NAME || PRODUCT_RADIO_NAMES.includes(fieldKey);

          if (shouldShow) {
            item.style.display = '';
            setDisabledWithin(item, false);
          } else {
            // 非表示 → 値クリアして、入力も無効化（FormDataから除外）
            if (fieldKey !== FIXED_NUMBER_DEVICE_FIELD) {
              clearValuesWithin(item);
            } else {
              // 「解約デバイス数」は固定で 1 を保持
              const el = item.querySelector(`#contact_device_id, input[name="${FIXED_NUMBER_DEVICE_FIELD}"]`);
              if (el) el.value = '1';
            }
            setDisabledWithin(item, true);
            item.style.display = 'none';
          }
        });
        return;
      }

      if ($buttonItem) $buttonItem.style.display = '';
      const allowed = VISIBLE_FIELDS_BY_PRODUCT_ID[productId];

      // 定義漏れは全部表示に倒す
      if (!allowed) {
        console.warn('[cancelForm2] Unknown productId:', productId);
        getAllFieldItems().forEach((item) => (item.style.display = ''));
        return;
      }

      getAllFieldItems().forEach((item) => {
        const fieldKey = item.getAttribute('data-fields');
        // 「どちらのストアで購入？」は、商品プランではなく購入ストアにだけ依存させる
        // - amazon・楽天購入：表示
        // - 公式サイト購入：非表示
        const isOtherStoreDetail = fieldKey === OTHER_STORE_DETAIL_FIELD;
        const shouldShow = isOtherStoreDetail
          ? storeId === 'purchase_store_other'
          : ALWAYS_VISIBLE_FIELDS.has(fieldKey) || allowed.has(fieldKey);

        if (shouldShow) {
          // 表示 → 入力も有効化
          item.style.display = '';
          setDisabledWithin(item, false);
        } else {
          // 非表示 → 値クリアして、入力も無効化（FormDataから除外）
          clearValuesWithin(item);
          setDisabledWithin(item, true);
          item.style.display = 'none';
        }
      });

      // Amazon/楽天の場合は、選択肢を「レンタルCoco」に固定（誤操作防止）
      if (storeId === 'purchase_store_other') {
        PRODUCT_RADIO_NAMES.forEach((n) => {
          document.querySelectorAll(`input[type="radio"][name="${n}"]`).forEach((el) => {
            el.disabled = true;
          });
        });
        const coco = document.getElementById('purchase_coco_renatl');
        if (coco) coco.disabled = false;
      } else {
        // 公式サイトの場合は制限を解除
        PRODUCT_RADIO_NAMES.forEach((n) => {
          document.querySelectorAll(`input[type="radio"][name="${n}"]`).forEach((el) => {
            el.disabled = false;
          });
        });
      }

      // Amazon/楽天は「Cocoレンタル」を自動選択した直後にスクロール
      if (storeId === 'purchase_store_other') {
        requestAnimationFrame(() => {
          smoothScrollToPlanAttention();
        });
      }
    };

    // 初期反映
    wrapStoreRadioLabelTextWithSpan();
    applyVisibility();

    // 変更で反映
    document.addEventListener('change', (e) => {
      const t = e.target;
      if (!t) return;

      // 1) ストア選択
      if (t.matches(`input[type="radio"][name="${STORE_RADIO_NAME}"]`)) {
        // 公式サイト：製品選択はクリアして、次の選択を促す
        if (t.id === 'purchase_store_shopify') {
          PRODUCT_RADIO_NAMES.forEach((n) => {
            document.querySelectorAll(`input[type="radio"][name="${n}"]`).forEach((el) => {
              el.checked = false;
            });
          });
          applyVisibility();
          return;
        }

        // Amazon/楽天：レンタルCocoを自動選択して表示
        if (t.id === 'purchase_store_other') {
          const coco = document.getElementById('purchase_coco_renatl');
          if (coco) coco.checked = true;
          applyVisibility();
          return;
        }

        applyVisibility();
        return;
      }

      // 2) 製品ラジオ（公式サイト選択時のみ想定）
      if (t.matches(PRODUCT_RADIO_NAMES.map((n) => `input[type="radio"][name="${n}"]`).join(','))) {
        const storeId = getSelectedStoreId();
        if (storeId !== 'purchase_store_shopify') {
          // Amazon/楽天は固定なので何もしない（disabled のはずだが保険）
          return;
        }

        // どれか選んだら、他グループは全て解除（＝全体で 1 つだけ選択）
        const proceedAsUsual = () => {
          // どれか選んだら、他グループは全て解除（＝全体で 1 つだけ選択）
          const currentName = t.getAttribute('name');
          PRODUCT_RADIO_NAMES.forEach((n) => {
            if (n === currentName) return;
            document.querySelectorAll(`input[type="radio"][name="${n}"]`).forEach((el) => {
              if (el.checked) el.checked = false; // ★dispatchしない（ループ防止）
            });
          });

          applyVisibility();

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              smoothScrollToPlanAttention();
            });
          });
        };

        // ★追加：対象プランならポップアップを先に表示 → ☓で閉じたら従来挙動へ
        const normalizedId = normalizeProductId(t.id);
        if (POPUP_TARGET_PRODUCT_IDS.has(normalizedId)) {
          openCancelPlanPopup(() => {
            proceedAsUsual();
          });
          return;
        }

        // 対象外は従来どおり
        proceedAsUsual();
      }
    });

    function setDisabledWithin(item, disabled) {
      item.querySelectorAll('input, select, textarea').forEach((el) => {
        el.disabled = disabled;
      });
    }

    function smoothScrollToPlanAttention() {
      // 「製品プラン」側のラジオだけを見る（ストア選択等は除外）
      const PRODUCT_RADIO_NAMES_LOCAL = [
        'entry.1978710870', // 本体無料レンタル定期
        'entry.2050220363', // 消耗品のみ定期
        'entry.1153183485', // レンタル本体のみ
        'entry.1117288098', // プレミアムケア
      ];

      // 製品ラジオの中で checked を探す
      let selectedProductRadio = null;
      for (const name of PRODUCT_RADIO_NAMES_LOCAL) {
        const checked = document.querySelector(`input[type="radio"][name="${name}"]:checked`);
        if (checked) {
          selectedProductRadio = checked;
          break;
        }
      }

      // ターゲット決定
      let target = null;

      // プレミアムケアプランなら「お名前」へ（entry.814531238 のdl）
      if (selectedProductRadio && selectedProductRadio.id === 'purchase_care_plan') {
        target = document.querySelector('dl.contactForm__item[data-fields="entry.814531238"]');
      }

      // それ以外は従来どおり plan-attention
      if (!target) {
        target = document.getElementById('plan-attention');
      }

      // どちらも無ければ何もしない
      if (!target) return;

      // 非表示(display:none)だと位置計算できないので、表示されているかを最低限チェック
      const style = window.getComputedStyle(target);
      if (style.display === 'none' || style.visibility === 'hidden') {
        return;
      }

      // スムーススクロール
      const offset = 80; // 固定ヘッダー分（必要なら調整）
      const y = target.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({ top: y, behavior: 'smooth' });
    }

  }


  /**
   * contact_attachment があるページだけ
   * ファイル名抽出の interval を登録
   */
  setupAttachmentWatcher() {
    const input = document.getElementById('contact_attachment');
    const errorMsg = document.querySelector('.dropboxCheck');
    if (!input || !errorMsg) return;

    setInterval(() => {
      const raw = input.value;
      const matches = raw.match(/[a-zA-Z0-9_\-]+\.(jpg|jpeg|png|gif|webp)/gi) || [];
      const unique = [...new Set(matches)];
      input.value = unique.join(' ');
      errorMsg.style.display = unique.length > 0 ? 'none' : 'block';
    }, 500);
  }

  bindEvents() {
    // フォームのデフォルトの送信を防ぐ
    this.$form.on('submit', (e) => e.preventDefault());

    // 確認ボタンクリック時の処理
    this.$confirmButton.on('click', () => this.handleConfirm());

    // 編集に戻るボタンクリック時の処理
    this.$editButton.on('click', () => this.handleEdit());

    // 送信ボタンクリック時の処理
    this.$submitButton.on('click', () => this.handleSubmit());

    // チェックボックスの特別処理
    this.$form.find('input[type="checkbox"]').on('change', function () {
      const $field = $(this).closest('.contactForm__item');
      const errorMsg = $field.find('.errorMsg');
      if (this.checked) {
        errorMsg.css('display', 'none');
      }
    });
  }

  // 必須項目のバリデーション
  validateRequiredFields() {
    let isValid = true;
    const requiredFields = this.$form.find('.--require');

    requiredFields.each((_, field) => {
      const $field = $(field);
      const input = $field.find('input, textarea, select');
      const errorMsg = $field.find('.errorMsg');
      const value = input.val()?.trim(); // 空チェック用
      const inputType = input.attr('type') || input.prop('tagName').toLowerCase(); // inputタイプまたはタグを取得
      const nameAttr = input.attr('name');

      // 非表示のフィールドはバリデーション対象外にする
      if (!$field.is(':visible')) return;

      if (nameAttr === 'entry.1776017831') return;

      if (inputType === 'checkbox') {
        // チェックボックスのバリデーション
        if (!input.prop('checked')) {
          errorMsg.text('この項目は必須です').css('display', 'block');
          isValid = false;
        } else {
          errorMsg.css('display', 'none');
        }
      } else if (inputType === 'email') {
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const inputId = input.attr('id');

        // 確認用メール：形式チェック＋未入力（必須）だけ。存在チェック状態は見ない
        if (inputId === 'contact_email_confirm') {
          if (!value) {
            errorMsg.text('※メールアドレスを入力してください').css('display', 'block');
            isValid = false;
          } else if (!emailPattern.test(value)) {
            errorMsg.text('有効なメールアドレスを入力してください').css('display', 'block');
            isValid = false;
          } else {
            errorMsg.css('display', 'none');
          }
          return;
        }

        // 送信用メール：従来どおり（存在チェック込み）
        if (!emailPattern.test(value)) {
          errorMsg.text('有効なメールアドレスを入力してください').css('display', 'block');
          isValid = false;
        } else if (this.isCheckingEmail) {
          errorMsg.text('メールアドレスを確認中です。少しお待ちください。').css('display', 'block');
          isValid = false;
        } else if (this.emailExists === false) {
          errorMsg
            .text('ご登録のないメールアドレスです。レンタル時に登録したメールアドレスをご入力ください。')
            .css('display', 'block');
          isValid = false;
        } else {
          errorMsg.css('display', 'none');
        }

        return;

      } else if (inputType === 'tel') {
        const errorMsgText = (msg) => errorMsg.text(msg).css('display', 'block');

        const numericPattern = /^[0-9]+$/;
        const phonePattern = /^0\d{9,10}$/;

        if (!value) {
          errorMsgText('電話番号を入力してください');
          isValid = false;
        } else if (!numericPattern.test(value)) {
          errorMsgText('電話番号には数字のみを入力してください（ハイフンは不要です）');
          isValid = false;
        } else if (!phonePattern.test(value)) {
          errorMsgText('有効な電話番号を入力してください');
          isValid = false;
        } else {
          errorMsg.css('display', 'none');
        }
      } else if (inputType === 'radio') {
        // ラジオボタンのバリデーション
        if (input.filter(':checked').length == 0) {
          errorMsg.text('この項目は必須です').css('display', 'block');
          isValid = false;
        } else {
          errorMsg.css('display', 'none');
        }
      } else if (inputType === 'select') {
        // セレクトボックスのバリデーション
        if (!value || value === '選択してください') {
          errorMsg.text('この項目は必須です').css('display', 'block');
          isValid = false;
        } else {
          errorMsg.css('display', 'none');
        }
      } else {
        // 必須項目のバリデーション (共通)
        if (!value || value === '選択してください') {
          // 注文番号だけ文言を変えたい場合
          if (nameAttr === 'entry.1697080420') {
            errorMsg.text('※注文番号を入力してください').css('display', 'block');
          } else {
            errorMsg.text('この項目は必須です').css('display', 'block');
          }
          isValid = false;
        } else {
          errorMsg.css('display', 'none');
        }
      }
    });

    const input = document.getElementById('contact_attachment');
    const errorMsg = document.querySelector('.dropboxCheck');

    if (input && errorMsg) {
      setInterval(() => {
        const rawValue = input.value;
        const matches = rawValue.match(/[a-zA-Z0-9_\-]+\.(jpg|jpeg|png|gif|webp)/gi) || [];
        const uniqueFilenames = [...new Set(matches)];
        input.value = uniqueFilenames.join(' ');

        if (uniqueFilenames.length > 0) {
          errorMsg.style.display = 'none';
        } else {
          errorMsg.style.display = 'block';
        }
      }, 500);
    }

    const attachmentInput = document.getElementById('contact_attachment');
    const attachmentErrorMsg = attachmentInput?.parentElement.querySelector('.errorMsg');

    if (attachmentInput && attachmentErrorMsg) {
      const fileNames = attachmentInput.value.trim();
      if (!fileNames) {
        attachmentErrorMsg.style.display = 'block';
        isValid = false;
      } else {
        attachmentErrorMsg.style.display = 'none';
      }
    }

    // ============================
    // 追加：送信用メールと確認用メールの一致チェック
    // ============================
    const $mainEmail = this.$form.find('#contact_email');
    const $confirmEmail = this.$form.find('#contact_email_confirm');

    if ($mainEmail.length && $confirmEmail.length && $confirmEmail.closest('.contactForm__item').is(':visible')) {
      const mainVal = ($mainEmail.val() || '').trim();
      const confirmVal = ($confirmEmail.val() || '').trim();

      const $confirmField = $confirmEmail.closest('.contactForm__item');
      const $confirmError = $confirmField.find('.errorMsg');

      // main は required 側で空チェックされる前提だが、念のため
      if (mainVal && confirmVal && mainVal !== confirmVal) {
        $confirmError
          .text('※メールアドレスが一致しません。再入力してください')
          .css('display', 'block');
        isValid = false;
      }
    }

    // ============================
    // 追加：解約製品の選択（4グループのうち 1 つ必須）
    // ============================
    // cancelForm2 の入力画面でのみチェック
    if (this.formId === 'cancelForm2') {
      const PRODUCT_RADIO_NAMES = [
        'entry.1978710870',
        'entry.2050220363',
        'entry.1153183485',
        'entry.1117288098',
      ];

      const anySelected = PRODUCT_RADIO_NAMES.some((name) => {
        return this.$form.find(`input[type="radio"][name="${name}"]:checked`).length > 0;
      });

      // いずれも未選択なら、各グループのエラーを出す（見えているものだけ）
      if (!anySelected) {
        PRODUCT_RADIO_NAMES.forEach((name) => {
          const $groupInputs = this.$form.find(`input[type="radio"][name="${name}"]`);
          if (!$groupInputs.length) return;
          const $field = $groupInputs.first().closest('.contactForm__item');
          if (!$field.is(':visible')) return;
          $field.find('.errorMsg').text('この項目は必須です').css('display', 'block');
        });
        isValid = false;
      } else {
        // どれか選択されていれば、全グループのエラーは消す
        PRODUCT_RADIO_NAMES.forEach((name) => {
          const $groupInputs = this.$form.find(`input[type="radio"][name="${name}"]`);
          if (!$groupInputs.length) return;
          const $field = $groupInputs.first().closest('.contactForm__item');
          $field.find('.errorMsg').css('display', 'none');
        });
      }
    }


    return isValid;
  }

  // 入力されたEmailアドレスの存在チェック
  setupEmailExistCheck() {
    // 買い切り申請フォームで動作
    if (this.formId !== 'purchaseForm') return;

    const $emailInput = this.$form.find('#contact_email');
    if (!$emailInput.length) return;

    const $field = $emailInput.closest('.contactForm__item');
    const $errorMsg = $field.find('.errorMsg');

    // ステータスメッセージ用要素を追加
    let $statusMsg = $field.find('.emailCheckMsg');
    if (!$statusMsg.length) {
      $statusMsg = $('<p class="emailCheckMsg" style="margin-top:4px;font-size:12px;"></p>');
      $statusMsg.insertAfter($errorMsg);
    }

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    let timer = null;
    const endpoint = 'https://miruto-check-email-address.vc-dev.workers.dev/apps/customer/email-check';

    const execCheck = (email) => {
      if (!emailPattern.test(email)) {
        this.emailExists = null;
        $statusMsg.text('').hide();
        return;
      }

      this.isCheckingEmail = true;
      this.emailExists = null;

      $statusMsg
        .text('メールアドレスを確認しています…')
        .css('color', '#6a676b')
        .show();

      fetch(`${endpoint}?email=${encodeURIComponent(email)}`)
        .then(res => res.json())
        .then(data => {
          if (data && data.exists === true) {
            this.emailExists = true;
            $statusMsg
              .text('このメールアドレスはレンタル時に登録されたメールアドレスです。')
              .css('color', '#008000')
              .show();
          } else if (data && data.exists === false) {
            this.emailExists = false;
            $statusMsg
              .text('ご登録のないメールアドレスです。レンタル時に登録したメールアドレスをご入力ください。')
              .css('color', '#ef857d')
              .show();
          } else {
            this.emailExists = null;
            $statusMsg
              .text('メールアドレスの確認に失敗しました。時間をおいて再度お試しください。')
              .css('color', '#ef857d')
              .show();
          }
        })
        .catch(() => {
          this.emailExists = null;
          $statusMsg
            .text('メールアドレスの確認に失敗しました。時間をおいて再度お試しください。')
            .css('color', '#ef857d')
            .show();
        })
        .finally(() => {
          this.isCheckingEmail = false;
        });
    };

    // 入力が止まって 500ms 後 or blur でチェック
    $emailInput.on('input', () => {
      const email = $emailInput.val().trim();

      if (timer) clearTimeout(timer);
      timer = setTimeout(() => execCheck(email), 500);
    });

    $emailInput.on('blur', () => {
      const email = $emailInput.val().trim();
      if (!email) return;
      execCheck(email);
    });
  }

  /**
   * 名前・電話・メール・注文番号が Shopify 注文と一致するかを Workers でチェック
   * - true  : OK（確認画面へ進める）
   * - false : NG（注文番号欄にエラー表示）
   */
  async validateOrderAndCustomer() {
    // 買い切り申請フォーム以外では何もしない
    if (this.formId !== 'purchaseForm') return true;

    const $nameInput  = this.$form.find('#contact_name');
    const $telInput   = this.$form.find('input[type="tel"]');
    const $emailInput = this.$form.find('#contact_email');
    const $orderInput = this.$form.find('input[name="entry.1697080420"]');

    if (!$orderInput.length) return true; // 念のため

    const name  = $nameInput.val()?.trim()  || '';
    const phone = $telInput.val()?.trim()   || '';
    const email = $emailInput.val()?.trim() || '';
    const order = $orderInput.val()?.trim() || '';

    const $orderField    = $orderInput.closest('.contactForm__item');
    const $orderErrorMsg = $orderField.find('.errorMsg');

    // 「不明」または空欄はここではチェックしない（必須チェック側に任せる）
    if (!order || order === '不明') {
      // 念のためエラーメッセージを消しておく
      // （必須エラーは validateRequiredFields() が出す）
      if (order && order === '不明') {
        // 不明でも OK というメッセージを出したければここで
        // $orderErrorMsg.text('注文番号が不明の場合は「不明」で送信いただけます。').css('display', 'block');
      }
      return true;
    }

    // ▼ ここから追加：数字のみの場合は「4桁以上」でないとエラーにする
    // 全角数字は半角に、ハイフンなどは除外して長さを確認
    const numericOnly = order
      .replace(/[０-９]/g, ch => String.fromCharCode(ch.charCodeAt(0) - 0xFF10 + 0x30)) // 全角 → 半角
      .replace(/\D/g, ''); // 数字以外を除去

    // 「数字だけで構成されている & 4桁未満」の場合は形式エラー
    if (/^[0-9０-９]+$/.test(order) && numericOnly.length > 0 && numericOnly.length < 4) {
      $orderErrorMsg
        .text('注文番号は4桁以上の数字で入力してください。（例：1001）')
        .css('display', 'block');
      return false;
    }

    // Workers のエンドポイント
    const endpoint =
      'https://miruto-check-email-address.vc-dev.workers.dev/apps/order/validate';

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          order_number: order,
          name,
          phone,
          email,
        }),
      });

      const data = await res.json().catch(() => null);

      if (!data || data.valid !== true) {
        const reason = data && data.reason;

        if (reason === 'order_not_found') {
          $orderErrorMsg
            .text('この注文番号のご注文が見つかりません。注文確認メールまたはマイページから注文番号をご確認ください。')
            .css('display', 'block');
        } else if (reason === 'buyout_completed') {
          $orderErrorMsg
            .text('このご注文はすでに買い切り精算が完了しています。本フォームからの再申請は不要です。')
            .css('display', 'block');
        } else {
          $orderErrorMsg
            .text('入力されたお名前・電話番号・メールアドレスと注文番号の組み合わせが確認できませんでした。ご注文情報をご確認のうえ、再度ご入力ください。')
            .css('display', 'block');
        }

        return false;
      }

      // OK の場合はエラーを消す
      $orderErrorMsg.css('display', 'none');
      return true;
    } catch (e) {
      console.error('order validate error', e);
      // 通信エラー時は、とりあえず通す or 止めるかは運用ポリシー次第
      // 今回は「念のため止める」ほうが安全そう
      $orderErrorMsg
        .text('注文番号の確認に失敗しました。時間をおいて再度お試しください。')
        .css('display', 'block');
      return false;
    }
  }

  // フォームデータの収集
  collectFormData() {
    const formData = new FormData(this.$form[0]);
    this.displayData = {};
    this.formData = {};

    for (const [key, value] of formData.entries()) {
      // 確認用メールは送信しない（Googleフォーム項目なし）
      if (key === 'email_confirm') {
        continue;
      }

      if (value instanceof File) continue;

      // 日付フィールドの処理
      if (key.includes('entry.') && value.includes('-')) {
        const isPotentialDate = /^\d{4}-\d{2}-\d{2}$/.test(value);
        if (isPotentialDate) {
          try {
            const date = new Date(value);
            // 元のキーから年月日のキーを生成
            const baseKey = key.split('_')[0];

            // Google Forms送信用データ
            this.formData[`${baseKey}_year`] = date.getFullYear().toString();
            this.formData[`${baseKey}_month`] = (date.getMonth() + 1).toString();
            this.formData[`${baseKey}_day`] = date.getDate().toString();

            // 確認画面表示用データ
            this.displayData[key] = `${date.getFullYear()}/${(date.getMonth() + 1)
              .toString()
              .padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}`;
          } catch (e) {
            console.error('Date parsing error:', e);
            this.displayData[key] = value;
          }
        } else {
          // 日付形式でない場合（住所など）
          this.displayData[key] = value;
          this.formData[key] = value;
        }
      } else if (key.includes('entry.') && this.$form.find(`[name="${key}"]`).attr('type') === 'checkbox') {
        // チェックボックスの処理
        const $checkbox = this.$form.find(`[name="${key}"]`);
        if ($checkbox.prop('checked')) {
          const caption = $checkbox.next('label').text();
          const checkboxValue = $checkbox.val(); // value属性の値を取得
          this.displayData[key] = caption; // 表示用にはキャプションを使用
          this.formData[key] = checkboxValue; // 送信用にはvalue属性の値を使用
        }
      } else {
        // その他のフィールド
        this.formData[key] = value;
        this.displayData[key] = value;
      }
    }

    // デバッグ用：グローバルに公開
    window.contactData = {
      displayData: this.displayData,
      formData: this.formData,
    };

    // デバッグ用：コンソールに出力
    console.log('Display Data:', this.displayData);
    console.log('Form Data to be sent:', this.formData);
  }

  // 確認画面にデータを表示
  displayConfirmData() {
    const confirmFields = this.$confirmContent.find('.contactForm__item');

    confirmFields.each((_, field) => {
      const $field = $(field);
      const fieldName = $field.data('fields');
      const confirmContent = $field.find('.confirm_content');

      // ★ 「どちらのストアでご購入？」（entry.843060629）は amazon・楽天購入のときだけ確認画面に出す
      if (fieldName === 'entry.843060629') {
        const storeChecked = document.querySelector('input[type="radio"][name="entry.801466152"]:checked');
        const isOtherStore = storeChecked && storeChecked.id === 'purchase_store_other';

        if (!isOtherStore) {
          $field.hide();
          return; // この行は以降の処理をスキップ
        }
      }

      if (fieldName && this.displayData[fieldName]) {
        confirmContent.text(this.displayData[fieldName]);
        $field.show();
      } else {
        // ★ 値が無いconfirm行は非表示（4分割productにも効く）
        $field.hide();
      }
    });

    // 確認画面のボタンを表示させる
    const confirmButton = document.querySelector('[data-state="confirm"] .contactForm__item.--button');
    if (confirmButton) {
      confirmButton.style.display = '';
    }
  }

  // Google Formsへのデータ送信
  async submitToGoogleForms() {
    const formUrl = this.formEndpoints[this.formId];
    if (!formUrl) {
      console.error('Form endpoint not found');
      return false;
    }

    try {
      await fetch(formUrl, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(this.formData),
      });

      return true;
    } catch (error) {
      console.error('Form submission error:', error);
      return false;
    }
  }

  // 確認ボタン処理
  async handleConfirm() {
    const $buttonErrorMsg = this.$inputContent.find('.--button .errorMsg');

    // 1. 必須チェック
    if (!this.validateRequiredFields()) {
      $buttonErrorMsg.css('display', 'block');
      return;
    }

    // 2. 注文番号＋顧客情報の照合（買い切りフォームのみ実行）
    const isOrderValid = await this.validateOrderAndCustomer();
    if (!isOrderValid) {
      // 注文番号欄にエラーが出ているのでボタン下にもエラーを出しておく
      $buttonErrorMsg.css('display', 'block');
      return;
    }

    // 3. すべて OK → 確認画面へ
    $buttonErrorMsg.hide();

    this.collectFormData();
    this.displayConfirmData();

    this.$inputContent.css('display', 'none');
    this.$confirmContent.css('display', 'block');

    console.log('=== Confirmation Data ===');
    console.log('Data to be displayed:', window.contactData.displayData);
    console.log('Data to be sent:', window.contactData.formData);

    window.scrollTo(0, 0);
  }

  // 編集に戻る処理
  handleEdit() {
    this.$confirmContent.css('display', 'none');
    this.$inputContent.css('display', 'block');

    // ページトップにスクロール
    window.scrollTo(0, 0);
  }

  // 送信処理
  async handleSubmit() {
    const success = await this.submitToGoogleForms();

    if (success) {
      this.$confirmContent.css('display', 'none');
      this.$completeContent.css('display', 'block');

      // ページトップにスクロール
      window.scrollTo(0, 0);

      // フォームをリセット
      this.$form[0].reset();
    } else {
      alert('送信に失敗しました。もう一度お試しください。');
    }
  }
}

// インスタンス化
document.addEventListener('DOMContentLoaded', () => {
  new ContactPage();
});

document.addEventListener('DOMContentLoaded', function () {
  const targets = [
    {
      id: 'purchase_lala_renatl_cat-litter',
      html: 'スマートトイレLala<br>ねこ砂定期便',
    },
    {
      id: 'purchase_coco_renatl_cat-litter',
      html: 'スマートトイレCoco<br>ねこ砂定期便',
    },
    {
      id: 'purchase_mimi_rental_cat-litter',
      html: 'スマートトイレMimi<br>ねこ砂定期便',
    },
    {
      id: 'purchase_mona_rental_water-dispenser-filter',
      html: '自動給水器Mona<br>フィルター定期便',
    },
    {
      id: 'purchase_subsc_cat-litter',
      html: 'ねこ砂定期便',
    },
    {
      id: 'purchase_subsc_filter',
      html: 'フィルター定期便',
    },
    {
      id: 'purchase_coco_renatl',
      html: 'スマートトイレCoco',
    },
    {
      id: 'purchase_mimi_renatl',
      html: 'スマートトイレMimi',
    },
    {
      id: 'purchase_mona_renatl',
      html: '自動給水器Mona',
    },
    {
      id: 'purchase_milo_set_renatl',
      html: 'ヘルスチェック首輪Milo<br>基本セット',
    },
    {
      id: 'purchase_milo_core_renatl',
      html: 'ヘルスチェック首輪Milo<br>コア単品',
    },
    {
      id: 'purchase_milo_home_renatl',
      html: 'ヘルスチェック首輪Milo<br>ホーム単品',
    },
    {
      id: 'purchase_care_plan',
      html: 'プレミアムケアプラン',
    },
  ];

  targets.forEach((item) => {
    const label = document.querySelector(`label[for="${item.id}"]`);
    if (!label) return;

    label.innerHTML = `<span>${item.html}</span>`;
  });
});




